// extracted by mini-css-extract-plugin
module.exports = {"container":"ReintegrateForm_container__3mC4u","actionBtn":"ReintegrateForm_actionBtn__5PL8r"};